module.exports = __webpack_public_path__ + "static/media/freya.0760bc21.png";